import React from 'react';
import classNames from 'classnames';
import Tappable from 'app/components/commons/Tappable';
import { Link } from 'react-router-dom';
import useSheet from 'app/jss';
import colorUtils from 'color';
import Icon from 'app/components/commons/Icon';

type Props = {
  classes: object,
  icon: string,
  text: string,
  color: string,
  link?: string,
  onClick?: () => void,
};

type State = {};

class FriendInfoMessageItem extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    link: undefined,
    onClick: undefined,
  };

  render() {
    const {
      classes,
      color,
      icon,
      text,
      link,
      onClick,
    } = this.props;

    return (
      <div className={classNames(classes.step, color)} key={icon}>
        <Tappable
          component={link ? Link : 'div'}
          onTap={onClick}
          className={classes.stepIconContainer}
          to={link}
        >
          <Icon
            type={icon}
            className={classes.stepIcon}
          />
        </Tappable>
        <span className={classes.stepText}>{text}</span>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    step: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '&.primary': {
        color: theme.color.basis3,
        '& $stepIconContainer': {
          color: theme.color.basis3,
          borderColor: colorUtils(theme.color.primary).alpha(0.3).toString(),
        },
      },
      '&.pending': {
        color: theme.color.basis4,
        '& $stepIconContainer': {
          color: theme.color.basis4,
          borderColor: theme.color.basis6,
        },
      },
    },
    stepIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '100%',
      height: 80,
      width: 80,
      border: {
        width: 7,
        style: 'solid',
      },
      marginBottom: 5,
    },
    stepIcon: {
      height: 30,
      width: 30,

    },
    stepText: {
      marginTop: 3,
      fontSize: 12,
      lineHeight: '13px',
      fontWeight: 600,
      textTransform: 'uppercase',
      textAlign: 'center',
      maxWidth: 80,
    },
  };
}

export default useSheet(applyStyles)(FriendInfoMessageItem);
